import { Badge, Card, Row, Tooltip } from 'antd';
import * as Icons from '@ant-design/icons';
import { } from '@ant-design/icons';
import React, { Component, HTMLAttributeAnchorTarget, useContext } from 'react';
import AppContext, { AppContextProps } from '../components/infrastructure/appContext';
import './home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen, faComments, faPlusCircle, faFolderPlus, faListAlt, faQuestionCircle, IconDefinition, faTrashAlt, faTrashCan, faScrewdriverWrench, faSearchPlus, faFileCircleCheck, faBusinessTime, faFileEdit, faCalculator, faClipboardQuestion, faClipboardCheck, faEnvelopesBulk, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { Transform } from '@fortawesome/fontawesome-svg-core';
import { IComponentItem } from '../components/infrastructure/models';
import { isMobile } from 'react-device-detect';
import { LinkIcon as FaqLinkIcon } from './help';

interface LinkIconProps {
    originalItem?: IComponentItem;
    name?: string;
    icon: IconDefinition | string;
    transformIcon?: Transform;
    to?: string;
    pathname?: string;
    search?: string;
    title?: string;
    colorClass: string;
    content?: string;
    target?: HTMLAttributeAnchorTarget;
    tooltip?: string;
    isCustomLink?: boolean;
}

interface TrashMenuItemProps {
    removeItem: (item: IComponentItem) => void;
}

class TrashMenuItem extends Component<TrashMenuItemProps, { over: boolean; showTooltip: boolean; }>{
    trashMenuItemRef?: HTMLDivElement | null;
    constructor(props: TrashMenuItemProps) {
        super(props)
        this.state = {
            over: false,
            showTooltip: false
        }
    }
    componentDidMount() {
        this.trashMenuItemRef?.addEventListener('removeMenuItem', this.removeItem);
        this.trashMenuItemRef?.addEventListener('onTrashOver', this.onTrashOver);
        this.trashMenuItemRef?.addEventListener('onDragItem', this.onDragItem);
    }
    componentWillMount() {
        this.trashMenuItemRef?.removeEventListener('removeMenuItem', this.removeItem);
        this.trashMenuItemRef?.removeEventListener('onTrashOver', this.onTrashOver);
        this.trashMenuItemRef?.removeEventListener('onDragItem', this.onDragItem);
    }
    removeItem = (e: Event) => {
        this.props.removeItem((e as CustomEvent).detail);
    }
    onTrashOver = (e: Event) => {
        this.setState({ over: (e as CustomEvent).detail });
    }
    onDragItem = (e: Event) => {
        this.setState({ showTooltip: (e as CustomEvent).detail });
    }
    render() {
        return (
            <div id={"home-trash"}
                ref={node => this.trashMenuItemRef = node}
                style={{ display: 'none', alignItems: 'center' }}>
                <Tooltip id="home-trash-tooltip" visible={this.state.showTooltip} title={'برای حذف منو، اینجا رها نمایید'}>
                    <FontAwesomeIcon icon={this.state.over ? faTrashCan : faTrashAlt} size={this.state.over ? '4x' : '3x'} style={{ position: 'absolute', bottom: 80 }} title="حذف" />
                </Tooltip>
            </div>
        );
    }
}

const LinkIcon = (props: LinkIconProps) => {
    const [over, setOver] = React.useState<boolean>(false);
    const { getPanelInfo } = useContext(AppContext);
    const panelInfo = getPanelInfo();
    const count = props.name && panelInfo ? panelInfo.data.filter(d => d.key === props.name).length : 0;
    let MenuIcon: any | undefined;
    if (typeof props.icon === 'string')
        MenuIcon = (Icons as any)[props.icon as string];

    const onDrag = (e: React.DragEvent<HTMLDivElement>) => {
        const trashIcon = document.getElementById("home-trash");
        if (trashIcon)
            trashIcon.dispatchEvent(new CustomEvent('onTrashOver', { detail: !!document.elementFromPoint(e.clientX, e.clientY)?.closest("#home-trash") }));
    };

    const onDragStart = (_: React.DragEvent<HTMLDivElement>) => {
        const trashIcon = document.getElementById("home-trash");
        if (trashIcon) {
            trashIcon.style.display = "block";
            trashIcon.dispatchEvent(new CustomEvent('onDragItem', { detail: true }));
        }
    };

    const onDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
        document.elementFromPoint(e.clientX, e.clientY)?.closest("#home-trash")?.dispatchEvent(new CustomEvent('removeMenuItem', { detail: props.originalItem }));

        const trashIcon = document.getElementById("home-trash");
        if (trashIcon) {
            trashIcon.style.display = "none";
            trashIcon.dispatchEvent(new CustomEvent('onDragItem', { detail: false }));
        }
    };

    const extraParams = props.isCustomLink ? { draggable: true, onDrag, onDragStart, onDragEnd } : {};

    return (
        <Link to={props.to ? props.to : { pathname: props.pathname, search: props.search }}
            target={props.target}
            onMouseOver={() => setOver(true)}
            onMouseLeave={() => setOver(false)}
        >
            <Tooltip title={props.tooltip}>
                <div {...extraParams}
                    className={"btn-big"}
                    style={{ margin: "0 15px 15px 0" }}
                >
                    <div className={`icon ${props.colorClass}`} style={{ marginTop: isMobile || over ? -15 : -10 }}>
                        {
                            !!MenuIcon
                                ? <MenuIcon style={{ fontSize: 48, verticalAlign: 'baseline' }} />
                                : <FontAwesomeIcon className={props.colorClass} icon={props.icon as IconDefinition} size={'3x'} transform={props.transformIcon} />
                        }
                    </div>
                    <div className="label bottom">

                        <span className="title" style={{ display: 'inline-flex', margin: isMobile || over ? 3 : 0, fontSize: isMobile || over ? 10 : 13 }}>
                            {props.title}
                            {!!count && <Badge className="panel-badge" count={count} style={{ marginTop: isMobile || over ? -6 : -3 }} />}
                        </span>
                        <span className="content" style={{ whiteSpace: isMobile || over ? 'pre-line' : 'nowrap', fontSize: isMobile || over ? 9 : 12 }}>{props.content}</span>
                    </div>
                </div>
            </Tooltip>
        </Link>
    );
}

export class Home extends Component<{}, {
    policyholderId?: number;
    evaluatorId?: number;
    repairCenterId?: number;
    insurerCenterId?: number;
    isPolicyholder?: boolean;
    userFullName?: string | null;
    reports?: { url: string; title: string; icon: string; }[];
    extraHomeMenuItems: IComponentItem[];
}> {
    static displayName = Home.name;
    static contextType = AppContext;
    tashElement?: HTMLDivElement
    constructor(props: {}) {
        super(props)
        this.state = {
            extraHomeMenuItems: []
        };
    }
    onMouseUp = (e: Event) => {
        this.addMenuItem((e as CustomEvent).detail);
    }
    addMenuItem = (newItem: IComponentItem) => {
        if (!this.state.policyholderId) {
            // to do add menu item in home page
            const extraHomeMenuItems = [...this.state.extraHomeMenuItems, newItem];
            localStorage.setItem(`homeMenu_${this.state.userFullName!}`, JSON.stringify(extraHomeMenuItems))
            this.setState({ extraHomeMenuItems });
        };
    }
    removeItem = (item: IComponentItem) => {
        if (!this.state.policyholderId) {
            // to do remove menu item from home page
            const extraHomeMenuItems = [...this.state.extraHomeMenuItems];
            extraHomeMenuItems.splice(extraHomeMenuItems.indexOf(item), 1);
            localStorage.setItem(`homeMenu_${this.state.userFullName!}`, JSON.stringify(extraHomeMenuItems))
            this.setState({ extraHomeMenuItems });
        };
    }
    componentDidMount() {
        const contentContainer = document.getElementById("content-container");
        if (contentContainer) {
            //contentContainer.style.backgroundColor = "rgb(207 218 219)";
            contentContainer.addEventListener('dragEndMenuItem', this.onMouseUp);
        }

        const { getUserInfo, getMenuItems } = this.context as AppContextProps;
        const userInfo = getUserInfo();
        const menuItems = getMenuItems();

        const reports = menuItems.filter(i => i.Path?.includes("/damagecasereport?"))
            .map(i => { return { url: i.Path!, title: i.Title!, icon: i.Icon! }; });

        const menuName = `homeMenu_${userInfo!.userFullName!}`;
        const extraHomeMenuItems = localStorage.getItem(menuName) ? JSON.parse(localStorage.getItem(menuName)!) : [];

        this.setState({
            userFullName: userInfo?.userFullName,
            policyholderId: userInfo?.extraVariables["PolicyholderId"],
            evaluatorId: userInfo?.extraVariables["EvaluatorId"],
            repairCenterId: userInfo?.extraVariables["RepairCenterId"],
            insurerCenterId: userInfo?.extraVariables["InsurerCenterId"],
            isPolicyholder: userInfo?.extraVariables["IsPolicyholder"],
            reports,
            extraHomeMenuItems
        });
    }
    componentWillUnmount() {
        const contentContainer = document.getElementById("content-container");
        if (contentContainer) {
            //contentContainer.style.backgroundColor = "#FFF";
            contentContainer.removeEventListener('dragEndMenuItem', this.onMouseUp);
        }
    }
    render() {
        const { getMenuItems } = this.context as AppContextProps;
        const menuItems = getMenuItems();

        const reports = (
            this.state.reports && this.state.reports.length ?
                this.state.reports.map(r =>
                    <LinkIcon key={r.url} to={r.url} icon={r.icon} transformIcon={{ flipX: true }} title={r.title} colorClass="font-lemon" />
                ) : []
        );

        const access = menuItems.map(m => m.Path);
        const extraHomeLinkIcons = this.state.extraHomeMenuItems
            .filter(i => access.includes(i.Path))
            .map(i => <LinkIcon originalItem={i} key={i.Path} isCustomLink to={i.Path} icon={i.Icon!} transformIcon={{ flipX: true }} title={i.Title} colorClass="font-lemon" />)

        if (!!this.state.policyholderId) {
            const policyholderMenu = (
                <>
                    <LinkIcon to="/policylist" icon={faListAlt} transformIcon={{ flipX: true }} title="بیمه های من" content="مشاهده بیمه‌نامه‌های خریداری شده" colorClass="font-blue-light" />
                    <LinkIcon to="/damagecasecreate" icon={faFolderPlus} title="ثبت خسارت بیمه نامه" content="در صورتی که در حال حاضر صاحب بیمه نامه هستید از این قسمت ثبت خسارت نمایید" colorClass="font-green-light" />
                    <LinkIcon name="DamageCasePolicyholder" to="/damagecasepolicyholder" icon={faFolderOpen} title="پیگیری پرونده های خسارت بیمه" content="مشاهده جزئیات پرونده و پیگیری خسارت‌های جاری" colorClass="font-lemon" />
                </>
            )

            return (
                <div className="wrapper" style={{ marginTop: 30 }} >
                    <Card title={<h4><b>مشتری گرامی، به پورتال مشتریان شرکت زبده خوش آمدید</b></h4>}
                        style={{ marginLeft: 20, marginRight: 20, backgroundColor: "transparent", border: 'none', textAlign: 'justify' }}>
                        {this.state.isPolicyholder ? <>
                            <h6>
                                ضمن سپاس از انتخاب مجموعه سرویس‌های دیجیتالی شرکت زبده، در این بخش می توانید به اطلاعات بیمه نامه های خود و دریافت خدمات مختلف دسترسی داشته باشید:
                            </h6>
                            <ul>
                                <ol>
                                    <h6>  1- در صورتی که در حال حاضر صاحب بیمه هستید و دستگاه شما خسارت دیده و یا به سرقت رفته در قسمت <b><Link to="/damagecasecreate">"ثبت خسارت بیمه نامه"</Link></b> درخواست خود را ثبت نمایید.</h6>
                                </ol>
                                <ol>
                                    <h6>  2- اگر نیاز به تعمیرات خارج از تعهدات بیمه نامه و بصورت آزاد دارید در قسمت <b><Link to="/repaircasecreate">"ثبت درخواست تعمیرات (آزاد)"</Link></b> درخواست خود را ثبت نمایید.</h6>
                                </ol>
                            </ul>
                        </> :
                            <h6>  اگر نیاز به تعمیرات دستگاه الکترونیکی دارید در قسمت <b><Link to="/repaircasecreate">"ثبت درخواست تعمیرات (آزاد)"</Link></b> درخواست خود را ثبت نمایید.</h6>
                        }
                    </Card>

                    <div style={{ width: "100%", display: 'flex', textAlign: "center", justifyContent: "center" }}>
                        <Row className="center">
                            {this.state.isPolicyholder && policyholderMenu}
                            <LinkIcon to="/inquirypolicy" icon={faPlusCircle} title="استعلام بیمه نامه" content="اگر بیمه نامه ای دارید که در پنل شما موجود نیست، جهت ثبت خسارت روی بیمه نامه، ابتدا از این قسمت نسبت به استعلام با IMEI و سریال دستگاه اقدام نمایید" colorClass="font-blue" />
                            <LinkIcon to="/repaircasecreate" icon={faFolderPlus} title="ثبت در خواست تعمیرات (آزاد)" content="اگر تمایل به تعمیرات آزاد خارج از بیمه نامه دارید در این قسمت درخواست تعمیرات را ثبت نمایید" colorClass="font-orange" />
                            <LinkIcon name="RepairCasePolicyholder" to="/repaircasepolicyholder" icon={faScrewdriverWrench} title="پیگیری تعمیرات (آزاد)" content="مشاهده جزئیات و پیگیری درخواست‌های تعمیرات آزاد" colorClass="font-red-light" />
                            <LinkIcon pathname="https://www.si24.ir/fa/services/form_Criticism/add/template/defaultTemplate/swd_id/54504" icon={faComments} transformIcon={{ flipX: true }} title="ثبت انتقادات و نارضایتی ها" target="_blank" colorClass="font-lemon" />
                            <LinkIcon to="/help" icon={faQuestionCircle} transformIcon={{ flipX: true }} title="راهنمای نرم افزار" colorClass="font-green" />
                            <FaqLinkIcon to={"/faq"} icon="faq" transformIcon={{ flipX: true }} title="پرسش های متداول" height={115} colorClass="font-lemon" />
                        </Row>
                    </div>
                </div>
            );
        }
        else if (!!this.state.evaluatorId || !!this.state.repairCenterId) {
            const readOnly = !menuItems.filter(i => i.Item && ["AllocateEvaluator", "DocumentCheck", "ContactSetting", "MakingContact", "DamageEstimation"].indexOf(i.Item) > -1).length;
            return (
                <div className="wrapper" style={{ width: "100%", display: 'flex', textAlign: "center", justifyContent: "center", marginTop: 30 }}>
                    <div>
                        <Row className="center">
                            {menuItems.filter(i => i.Item === "DamageCaseEvaluator").length !== 0 && <LinkIcon name="DamageCaseEvaluator" to={"/damagecaseevaluator"} icon={faListAlt} transformIcon={{ flipX: true }} title="همه پرونده ها" colorClass="font-blue-light" />}
                            {menuItems.filter(i => i.Item === "AllocateEvaluator").length !== 0 && this.state.evaluatorId === 1 && <LinkIcon name="AssignEvaluator" to={`/refresh?${encodeURIComponent("/damagecaseevaluator?status=assignevaluator")}`} icon={faSearchPlus} title="پرونده های جدید" colorClass="font-green-light" />}
                            {menuItems.filter(i => i.Item === "DocumentCheck").length !== 0 && <LinkIcon name="DocumentCheck" to={`/refresh?${encodeURIComponent("/damagecaseevaluator?evaluationstatus=documentcheck")}`} icon={faFileCircleCheck} title="بررسی مدارک" colorClass="font-purple-light" />}
                            {menuItems.filter(i => i.Item === "ContactSetting").length !== 0 && <LinkIcon name="ContactSetting" to={`/refresh?${encodeURIComponent("/damagecaseevaluator?evaluationstatus=contactsetting")}`} icon={faBusinessTime} transformIcon={{ flipX: true }} title="تنظیم تاریخ و زمان" content="تنظیم تاریخ و زمان تماس تصویری یا مراجعه حضوری" colorClass="font-lemon" />}
                            {menuItems.filter(i => i.Item === "MakingContact").length !== 0 && <LinkIcon name="MakingContact" to={`/refresh?${encodeURIComponent("/damagecaseevaluator?evaluationstatus=makingcontact")}`} icon={faFileEdit} title="ثبت نتیجه" content="ثبت نتیجه تماس تصویری یا مراجعه حضوری" colorClass="font-orange" />}
                            {menuItems.filter(i => i.Item === "ReceiveEssentials").length !== 0 && <LinkIcon name="ReceiveEssentials" to={`/refresh?${encodeURIComponent("/damagecaseevaluator?evaluationstatus=sendessentials")}`} icon={faEnvelopesBulk} title="دریافت دستگاه و متعلقات یا اصل مدارک" colorClass="font-green-light" />}
                            {menuItems.filter(i => i.Item === "DamageEstimation").length !== 0 && <LinkIcon name="DamageEstimation" to={`/refresh?${encodeURIComponent("/damagecaseevaluator?evaluationstatus=damageestimation")}`} icon={faCalculator} transformIcon={{ flipX: true }} title="برآورد خسارت" colorClass="font-blue" />}
                            {menuItems.filter(i => i.Item === "DamageEstimation").length !== 0 && <LinkIcon name="PolicyholderConfirmation" to={`/refresh?${encodeURIComponent("/damagecaseevaluator?evaluationstatus=policyholderconfirmation")}`} icon={faClipboardQuestion} transformIcon={{ flipX: true }} title="منتظر تأیید بیمه گزار/مشتری" colorClass="font-purple" />}
                            {menuItems.filter(i => i.Item === "ReceiveDepreciated").length !== 0 && <LinkIcon name="ReceiveDepreciated" to={`/refresh?${encodeURIComponent("/receivedepreciated")}`} icon={faClipboardCheck} title="دریافت داغی و تأیید انتقال مالکیت" colorClass="font-orange" />}
                            {menuItems.filter(i => i.Item === "DamageCaseVoucherPaymentDraft").length !== 0 && <LinkIcon name="DamageCaseVoucherPaymentDraft" to={`/refresh?${encodeURIComponent("/damagecasevoucherpaymentdraft")}`} icon={faFileInvoiceDollar} title="در انتظار پرداخت" colorClass="font-green-light" />}
                            {menuItems.filter(i => i.Item === "RepairCaseCenter").length !== 0 && <LinkIcon name="RepairCaseCenter" to={`/refresh?${encodeURIComponent("/repaircasecenter")}`} icon={faScrewdriverWrench} transformIcon={{ flipX: true }} title="پرونده های تعمیرات" colorClass="font-red-light" />}
                            {readOnly && menuItems.filter(i => i.Item === "Center").length !== 0 && <LinkIcon name="Center" to={"/center"} icon={faListAlt} transformIcon={{ flipX: true }} title="مراکز" colorClass="font-lemon" />}
                            {readOnly && menuItems.filter(i => i.Item === "Policy").length !== 0 && <LinkIcon name="Policy" to={"/policy"} icon={faListAlt} transformIcon={{ flipX: true }} title="بیمه نامه ها" colorClass="font-lemon" />}
                            {reports}
                            {extraHomeLinkIcons}
                            <LinkIcon to="/help" icon={faQuestionCircle} transformIcon={{ flipX: true }} title="راهنمای نرم افزار" colorClass="font-green" />
                            <FaqLinkIcon to={"/faq"} icon="faq" transformIcon={{ flipX: true }} title="پرسش های متداول" height={115} colorClass="font-lemon" />
                        </Row>
                        <TrashMenuItem removeItem={this.removeItem} />
                    </div>
                </div>
            );
        }
        return (
            <div className="wrapper" style={{ width: "100%", display: 'flex', textAlign: "center", justifyContent: "center", marginTop: 30 }} >
                <div>
                    <Row className="center">
                        {!!this.state.insurerCenterId && menuItems.filter(i => i.Item === "DamageCaseEvaluator").length !== 0 && <LinkIcon name="DamageCaseEvaluator" to={"/damagecaseevaluator"} icon={faListAlt} transformIcon={{ flipX: true }} title="همه پرونده ها" colorClass="font-blue-light" />}
                        {!!this.state.insurerCenterId && menuItems.filter(i => i.Item === "Center").length !== 0 && <LinkIcon name="Center" to={"/center"} icon={faListAlt} transformIcon={{ flipX: true }} title="مراکز" colorClass="font-red-light" />}
                        {!!this.state.insurerCenterId && menuItems.filter(i => i.Item === "Policy").length !== 0 && <LinkIcon name="Policy" to={"/policy"} icon={faListAlt} transformIcon={{ flipX: true }} title="بیمه نامه ها" colorClass="font-green-light" />}
                        {reports}
                        {extraHomeLinkIcons}
                        <LinkIcon to="/help" icon={faQuestionCircle} transformIcon={{ flipX: true }} title="راهنمای نرم افزار" colorClass="font-green" />
                        <FaqLinkIcon to={"/faq"} icon="faq" transformIcon={{ flipX: true }} title="پرسش های متداول" height={115} colorClass="font-lemon" />
                    </Row>
                </div>
            </div>
        );
    }
}

